export const userList = [
    {
      id: 1,
      image: require('./Users/Wireframe.svg').default,
      title: 'Loan Officers',
      description: 'Our app makes the loan application review process more efficient and accurate, enabling loan officers to spend less time on paperwork and more time interacting with clients.',
    },
    {
      id: 2,
      image: require('./Users/Wireframe(1).svg').default,
      title: 'Microfinance Institutions',
      description: 'Our app can help these lenders minimize the risk of loan defaults by analyzing borrower data and providing a risk score for each loan application.',
    },
    {
      id: 3,
      image: require('./Users/Wireframe(2).svg').default,
      title: 'Peer-to-Peer Lenders',
      description: 'Our app can help these lenders minimize the risk of loan defaults by analyzing borrower data and providing a risk score for each loan application.',
    },
    {
      id: 4,
      image: require('./Users/Wireframe(3).svg').default,
      title: 'Underwriters',
      description: 'Our app provides underwriters with the data they need to assess loan applications and make informed lending decisions, leading to reduced risk and increased profitability.',
    },
    {
      id: 5,
      image: require('./Users/Wireframe(4).svg').default,
      title: 'Financial Institutions',
      description: ' Our app is a valuable tool for financial institutions of all sizes, providing an easy-to-use platform for streamlining the lending process and minimizing risk.',
    },
    {
      id: 6,
      image: require('./Users/Wireframe(5).svg').default,
      title: 'Banks and Credit Unions',
      description: ': Our app helps banks and credit unions reduce the risk of loan defaults and make more informed lending decisions, leading to increased profitability.',
    }
  ];
  